@import "../../../styles/base";
@import "../Button/styles/surfaces";

.c-text-input {
  + .c-text-input {
    margin-top: 1.5rem;
  }

  &__input-wrapper {
    position: relative;
    border: 1px solid $ds-neutral-200;
    height: 3rem;
    border-radius: 0.25rem;
    color: $text;
    background-color: $white;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    font-size: $ds-font-size-b1;
  }

  &.is-medium &__input-wrapper {
    height: 2.5rem;
  }

  &__input {
    appearance: none;
    border: none;
    background: transparent;
    width: 100%;
    font-size: $ds-font-size-b1;
    padding: 1em;

    &:focus,
    &:active {
      outline: none;
      border: none;
      box-shadow: none;
    }
  }

  &.has-prefix &__input {
    padding-left: 0.25em;
  }

  &.has-suffix &__input {
    padding-right: 0.25em;
  }

  &:has(input:focus) &__input-wrapper {
    outline: none;
    border-color: transparent;
    box-shadow: $focus-shadow;
  }

  &.is-disabled &__input-wrapper {
    background-color: $ds-neutral-50;
  }

  &__input:disabled {
    color: $ds-neutral-700;
  }

  &--visually-enabled &__input:disabled,
  &--visually-enabled.is-disabled &__input-wrapper {
    background-color: transparent;
    color: $text;
    cursor: text;
  }

  &.is-invalid,
  &.is-invalid &__input-wrapper,
  &.is-invalid &__input {
    color: $invalid-color;
    align-items: center;
  }

  &__invalid-icon {
    display: block;
    margin: 0 0.25rem;
    height: 1.5rem;
    width: 1.5rem;
    background: $invalid-color;
    color: $white;
    border-radius: 100%;
    text-align: center;
    font-weight: 700;
  }

  &.is-invalid:not(:focus-within) &__input-wrapper {
    border-color: $invalid-color;
  }

  &__validation {
    margin-top: 0.25rem;
    font-size: $ds-font-size-b3;
  }

  &__prefix,
  &__suffix {
    @include button-group;
    display: flex;
    align-items: center;
    padding: 0.5rem;
    gap: 0.25rem;
  }

  &__icon {
    display: flex;
    align-items: center;
    padding: 0.5rem;
    margin-left: 0.5rem;
  }

  &__suffix:empty {
    display: none;
  }
}
